import { Component } from '@angular/core';
import { llamar, whats } from '../../utils/phone.utils';
import { SocialMedia } from 'src/app/models/utils/social-media.model';
import packageInfo from 'package.json';

@Component({
	selector: 'cmv-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
	public version: string = packageInfo.version;
	constructor() {}

	onCallAdvisor(): void {
		llamar();
	}

	onWriteWhatsApp(): void {
		whats();
	}

	abrirCMV(): void {
		window.open('https://www.cajamorelia.com.mx/', '_blank').focus();
	}
}
